import React from 'react';
import { Logo } from './Logo';
import { getWhatsAppLink } from '../utils/whatsapp';
const FOOTER_WHATSAPP_MESSAGE = 'Hola, equipo de Origen Studio. Quiero conocer más sobre sus sistemas digitales.';
const sistemasLinks = [{
  href: '#sistemas',
  label: 'Presencia Digital'
}, {
  href: '#sistemas',
  label: 'Automatización'
}, {
  href: '#sistemas',
  label: 'Sistema Completo'
}, {
  href: '#voice',
  label: 'VOICE'
}];
const origenLinks = [{
  href: '#como-funciona',
  label: 'Cómo funciona'
}];
export function Footer() {
  return <footer className="bg-carbon text-arena pt-12 md:pt-16 px-6 md:px-20 pb-12 md:pb-16" data-id="element-13" data-mp="387drhtbj3d5">
      <div className="max-w-[1200px] mx-auto" data-id="element-14" data-mp="3ldkf37uxairp">
        <div className="flex flex-col md:flex-row justify-between gap-12 md:gap-24 mb-16" data-id="element-15" data-mp="3qdf4t82yp2b6">
          {/* Left Column */}
          <div className="flex-1" data-id="element-16" data-mp="29ynm5mvmb9f2">
            <div className="mb-4" data-id="element-17" data-mp="29xlzsm95j0i1">
              <Logo variant="dark" data-id="element-18" data-mp="2eya05yj9stox" />
            </div>
            <p className="font-body text-[14px] text-arena/55 max-w-[360px] leading-relaxed" data-id="element-19" data-mp="2ez1ja9vokyyb">
              Sistemas digitales para empresas.
            </p>
          </div>

          {/* Link Columns */}
          <div className="flex-1 md:max-w-[480px] grid grid-cols-3 gap-8" data-id="element-20" data-mp="3gc0g7grppo61">
            <div data-id="element-21" data-mp="3v7zuj95f0kjm">
              <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-arena/40 mb-4" data-id="element-22" data-mp="3v8htidjgpcv8">
                SISTEMAS
              </span>
              <div className="flex flex-col gap-3" data-id="element-23" data-mp="82qrxrmhzrt7">
                {sistemasLinks.map(link => <a key={link.label} href={link.href} className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-24" data-mp="3472hh8p3xw3">
                    {link.label}
                  </a>)}
              </div>
            </div>
            <div data-id="element-25" data-mp="qtrns6sbn78j">
              <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-arena/40 mb-4" data-id="element-26" data-mp="qr5h09d98vrd">
                ORIGEN
              </span>
              <div className="flex flex-col gap-3" data-id="element-27" data-mp="tw60uddqc2pw">
                {origenLinks.map(link => <a key={link.label} href={link.href} className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-28" data-mp="yv90tjeurir0">
                    {link.label}
                  </a>)}
                <a href={getWhatsAppLink(FOOTER_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-29" data-mp="1clcl44u692dt">
                  Contacto
                </a>
              </div>
            </div>
            <div data-id="element-30" data-mp="3ocq1xuroio41">
              <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-arena/40 mb-4" data-id="element-31" data-mp="3od80wz5q7gfn">
                LEGAL
              </span>
              <div className="flex flex-col gap-3" data-id="element-32" data-mp="2ag5firxejeh6">
                <span className="font-body text-[13px] text-arena/40 cursor-default" data-id="element-33" data-mp="2agyg1b5rp7qv">
                  Privacidad
                </span>
                <span className="font-body text-[13px] text-arena/40 cursor-default" data-id="element-34" data-mp="21m0jlu3evcus">
                  Términos
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="pt-6 border-t border-arena/10" data-id="element-35" data-mp="2tdg3hgdl2lhb">
          <p className="font-body text-[12px] text-arena/30" data-id="element-36" data-mp="2pbuui6466rce">
            © 2026 ORIGEN STUDIO · Colombia
          </p>
        </div>
      </div>
    </footer>;
}